import Vue from 'vue';
import Vuex from 'vuex';
import help from './Help';
import window from './Window';
import biztDok from './BiztDok';
import { list } from './List';
import defaultStore from './DefaultStore';

Vue.use(Vuex);

export default class StoreFactory {
    constructor(tarifaModule) {
        if (typeof tarifaModule === 'undefined' || tarifaModule == null) {
            throw new Error('Tarifa store modul nincs definiálva');
        }

        this.state = {
            availablePages: [],
            currentPage: 0,
            felhasznalo: 0,
            ceg: 0,
            // theme: 'ovb_blue_theme',
            // theme: 'shared',
            // theme: 'ovb_purple_theme',
            // theme: 'ovb_sonne_theme',
            theme: '',
            // theme: 'light',
        };

        this.actions = {
            next: (context) => {
                context.commit('incrementPage');
            },

            back: (context) => {
                context.commit('decrementPage');
            },
        };
        this.mutations = {
            /* eslint-disable no-param-reassign */
            updateAvailablePages: (state, availablePages) => {
                state.availablePages = availablePages;
            },

            setNextPageAvailable: (state, available) => {
                state.availablePages[state.currentPage] = available;
                state.currentPage += 1;
            },

            incrementPage: (state) => {
                state.currentPage += 1;
            },

            decrementPage: (state) => {
                state.currentPage -= 1;
            },

            setCurrentPage: (state, page) => {
                state.currentPage = page;
            },

            setFelhasznalo: (state, felhasznalo) => {
                state.felhasznalo = felhasznalo;
            },

            setCeg: (state, ceg) => {
                state.ceg = ceg;
            },

            setTheme: (state, theme) => {
                state.theme = theme;
            },

            updateSzerzodo: (state, szerzodo) => {
                /// /console.log('updating szerzodo', szerzodo)
                state.ugyfel = szerzodo;
            },
            // setProp(state, payload) {
            //     ////console.log(payload)
            //     Vue.prototype.$setNestedPropVal(state, payload.path.split('.'), payload.value)
            // },
            /* eslint-enable no-param-reassign */
        };

        this.getters = {

            getTheme: (state) => state.theme,

            currentPage: (state) => state.currentPage,

            getAvailablePages: (state) => state.availablePages,

            isNextAvailable: (state) => state.availablePages[state.currentPage + 1],

            felhasznalo: (state) => state.felhasznalo,

            ceg: (state) => state.ceg,

        };

        this.tarifaModule = tarifaModule;
    }

    getStore(pages = 0) {
        for (let x = 0; x < pages; x += 1) {
            this.state.availablePages[x] = false;
        }
        this.state.availablePages[0] = true;

        // console.log(pages)

        const pagingModule = {
            state: this.state,
            getters: this.getters,
            mutations: this.mutations,
            actions: this.actions,
        };

        const tfModule = this.tarifaModule;
        const finalModulesDefinition = {
            pagingModule, tfModule, help, window, biztDok, list, defaultStore,
        };

        return new Vuex.Store({
            modules: finalModulesDefinition,
        });
    }
}
